import { registerTour } from "../tourRegistry";

function getSteps() {
  const totalSteps = 4;
  const stepCounter = (n) => `Step ${n} of ${totalSteps}`;

  return [
    {
      id: 'register-account-selector',
      title: `Account Selector <span class="t3-shepherd-step-count">${stepCounter(1)}</span>`,
      text: 'Choose which bank account to view. Each account has its own transaction register with running balances.',
      attachTo: { element: '[data-tour="banking-account-selector"]', on: 'bottom' },
      buttons: [
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'register-enter-tx',
      title: `Enter Transactions <span class="t3-shepherd-step-count">${stepCounter(2)}</span>`,
      text: 'Enter new bank transactions here — set the date, payee, account, fund, and amount. Transactions save instantly.',
      attachTo: { element: '[data-tour="banking-enter-tx"]', on: 'bottom' },
      beforeShowPromise() {
        // Expand the collapsible entry form so the tour can highlight it
        window.dispatchEvent(new Event("tour:expand-entry-form"));
        // Wait for the MUI Collapse animation to finish
        return new Promise((resolve) => setTimeout(resolve, 400));
      },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'register-table',
      title: `Transaction Register <span class="t3-shepherd-step-count">${stepCounter(3)}</span>`,
      text: 'Your transaction history sorted by date. Click any row to edit or inspect a transaction. Amounts automatically split into debit and credit columns.',
      attachTo: { element: '[data-tour="banking-register-table"]', on: 'top' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'register-actions',
      title: `Actions Menu <span class="t3-shepherd-step-count">${stepCounter(4)}</span>`,
      text: 'Use this menu to import transactions from CSV, connect to your bank via Plaid, or handle pending imported transactions.',
      attachTo: { element: '[data-tour="banking-actions"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Done',
          classes: 't3-shepherd-next-btn',
          action() { this.complete(); },
        },
      ],
    },
  ];
}

registerTour({
  id: 'register',
  pathPattern: '/upkeep/bank-accounts',
  getSteps,
  label: 'Register Tour',
});
